import {Fragment, PureComponent} from 'react'

import './FreelanceFilterType.scss'

export default class FreelanceFilterType extends PureComponent {
  constructor(props) {
    super(props)

    const state = {}
    props.topologies.forEach(topology => {
      state[topology.name] = props.searchQuery?.[topology.name] ?? null
    })
    this.state = state
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    let updateState = false
    const state = {}
    this.props.topologies.forEach(topology => {
      const oldProp = prevProps.searchQuery?.[topology.name] ?? null
      const newProp = this.props.searchQuery?.[topology.name] ?? null
      if (oldProp !== newProp) {
        state[topology.name] = this.props.searchQuery?.[topology.name] ?? null
        updateState = true
      }
    })

    if (updateState) {
      this.setState(state)
    }
  }

  onChecked = (event) => {
    const target = event.target

    const data = {}
    if (target.checked) {
      data[target.name] = target.value
    } else {
      data[target.name] = null
    }

    this.props.onChange(data)
    this.setState(data)
  }

  renderCheckbox = (name, label, value) => {
    return <div className="col-6 d-flex align-items-center checkbox">
      <input
        id={name + value}
        type="checkbox"
        name={name}
        onChange={this.onChecked}
        checked={this.state[name] === value}
        value={value}
      />
      <label htmlFor={name + value}>{label}</label>
    </div>
  }

  render() {
    const {topologies} = this.props

    return <Fragment>
      {topologies.map((item, key) => {
        return <div key={key} className="row">
          {this.renderCheckbox(item.name, item.labels[0], "1")}
          {this.renderCheckbox(item.name, item.labels[1], "0")}
        </div>
      })}
    </Fragment>
  }
}